var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFertilizerNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2663",
    d: "M20 8.129A17.778 17.778 0 1 1 2.222 25.907 17.8 17.8 0 0 1 20 8.129m0-2.222a20 20 0 1 0 20 20 20 20 0 0 0-20-20",
    transform: "translate(.5 -5.407)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2664",
    d: "M19.126 12.326A14.324 14.324 0 0 0 8.041 17.55l1.2 1.179a12.663 12.663 0 0 1 19.89.149l1.2-1.179a14.317 14.317 0 0 0-11.2-5.372",
    transform: "translate(1.317 -6.682)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2665",
    d: "M18.53 18.192a7.583 7.583 0 0 0-6.3 3.373l1.214 1.214a5.879 5.879 0 0 1 10.271.169l1.219-1.221a7.578 7.578 0 0 0-6.4-3.535",
    transform: "translate(1.914 -6.026)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2666",
    d: "M18.743 15.259a10.8 10.8 0 0 0-8.61 4.3l1.179 1.179a9.14 9.14 0 0 1 14.974.149l1.179-1.179a10.8 10.8 0 0 0-8.721-4.446",
    transform: "translate(1.7 -6.353)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2799"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2746",
    d: "M19.965 5.493A8.336 8.336 0 0 1 16.05 15.4a8.312 8.312 0 0 1-.681.327 5.007 5.007 0 0 1-.316.969 8.9 8.9 0 0 0 5.745-6 9.131 9.131 0 0 0-.014-5.274 7.212 7.212 0 0 0-.819.072",
    transform: "translate(7.748 17.424)",
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2747",
    d: "M7.439 16.4A8.295 8.295 0 0 1 .89 7.024a4.9 4.9 0 0 1-.666-.767 9.118 9.118 0 0 0 .859 6.327 9.02 9.02 0 0 0 6.024 4.552 7.376 7.376 0 0 0 .332-.731",
    transform: "translate(10.834 17.258)",
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2748",
    d: "M21.857 3.107a4.25 4.25 0 0 0-4.819-1.6 4.308 4.308 0 0 0-2.468 4.459c.037.272.163.423.374.449h.045a.407.407 0 0 0 .359-.22 7.049 7.049 0 0 1 2.762-1.853.41.41 0 0 0 .052-.021 6.984 6.984 0 0 1 3.279-.51.408.408 0 0 0 .444-.116.45.45 0 0 0-.027-.589",
    transform: "translate(7.853 18.251)",
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2749",
    d: "M6.881 4.708a.405.405 0 0 0-.389-.244A7.014 7.014 0 0 1 3.519 2.98a.359.359 0 0 0-.043-.035A7.084 7.084 0 0 1 1.4.339a.408.408 0 0 0-.324-.331C.864-.033.7.077.583.329a4.337 4.337 0 0 0 1.035 5.006 3.786 3.786 0 0 0 2.364.821 4.706 4.706 0 0 0 2.7-.9.446.446 0 0 0 .2-.551",
    transform: "translate(10.792 18.5)",
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2750",
    d: "M10.812 12.387a.438.438 0 0 0-.574.1.415.415 0 0 0-.015.462 7.14 7.14 0 0 1 .211 3.336.433.433 0 0 0-.008.056 7.139 7.139 0 0 1-1.2 3.116.411.411 0 0 0 .316.721h.079a4.282 4.282 0 0 0 3.787-3.406 4.3 4.3 0 0 0-2.6-4.384",
    transform: "translate(8.972 16.052)",
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2751",
    d: "M11 9.137a1.9 1.9 0 1 0-.9.228 1.9 1.9 0 0 0 .9-.228",
    transform: "translate(9.859 17.951)",
    style: {
      fill: "none",
      stroke: "#c5d75d",
      strokeWidth: ".5px"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2716",
    "data-name": "Gruppe 2716",
    transform: "translate(28 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2718",
    "data-name": "Gruppe 2718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2669",
    "data-name": "Pfad 2669",
    d: "M28.328,12.381a6.694,6.694,0,0,1-1.838,1.195,6.64,6.64,0,0,1-9.251-5.561c-.013-.173-.02-.352-.02-.531a6.393,6.393,0,0,1,.212-1.646,8.491,8.491,0,0,1,2.442-.358,8.641,8.641,0,0,1,8.455,6.9",
    transform: "translate(-17.219 -1.843)",
    fill: "#151517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2670",
    "data-name": "Pfad 2670",
    d: "M24.364,0A5.641,5.641,0,1,0,30,5.641,5.647,5.647,0,0,0,24.364,0",
    transform: "translate(-17.725)",
    fill: "#ff7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2671",
    "data-name": "Pfad 2671",
    d: "M26.226,7.155l-.409-2.836V2.473h1.625V4.319l-.372,2.836Zm-.382.707h1.6v1.6h-1.6Z",
    transform: "translate(-20.111 -0.832)",
    fill: "#f5f5f5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertilizerNoData);
export default __webpack_public_path__ + "static/media/fertilizer-no-data.f3b06a5d3205ce032438123058d89cd8.svg";
export { ForwardRef as ReactComponent };